import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';

export const usePopoverStyles = makeStyles({
  popover: {
    pointerEvents: 'none',
    margin: '1rem'
  },
  paper: {
    backgroundColor: 'white'
  },
  title: {
    borderBottom: `1px solid ${Colors.lightGray}`,
    padding: '1rem'
  },
  text: {
    padding: '1rem'
  }
});
